import { useMemo } from 'react'
import { useAuth } from 'hooks/auth/useAuth'
import { getSuperUserPages } from 'router/pages/superUserPages'
import { clientPages } from 'router/pages/clientPages'
import { bankPages } from 'router/pages/bankPages'
import { dealerPages } from 'router/pages/dealerPages'
import { flattenNavigation, type FlatPage } from './flattenNavigation'
import { matchesQuery } from './filterSearchItems'
import { capResults } from './filterSearchItems'

export function usePageSearchProvider() {
  const { userInfo } = useAuth()
  const role = userInfo?.role
  const isClient = role === 'client'
  const isBank = role === 'bankAgent'
  const isDealer = role === 'dealer'
  // Calls useAuth internally — must run unconditionally.
  const adminNavigation = getSuperUserPages()

  const pages = useMemo((): FlatPage[] => {
    if (isClient) return flattenNavigation(clientPages)
    if (isBank) return flattenNavigation(bankPages)
    if (isDealer) return flattenNavigation(dealerPages)
    return flattenNavigation(adminNavigation)
  }, [adminNavigation, isBank, isClient, isDealer])

  return { pages }
}

export function filterPages(pages: FlatPage[], query: string): FlatPage[] {
  const term = query.trim()
  if (!term) return capResults(pages)
  return capResults(
    pages.filter((page) => matchesQuery([page.title, page.segment, page.path, page.href], term)),
  )
}
